import { useLayoutEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { BackToTop } from "material-ui-back-to-top";

// COMPONENTS
import Header from './components/Header';
import Footer from './components/Footer';

// MUI
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import helpGuide from "./assets/help-guide.png";
import coinbaseTradeIcon from "./assets/icons/coinbase-trade-icon.png";
import walletSplash from "./assets/wallet-generation/splash.jpg";
import walletPrivacy from "./assets/wallet-generation/privacy.jpg";
import walletRecovery from "./assets/wallet-generation/recovery.jpg";

import walletRecPhrase1 from "./assets/wallet-generation/record-phrase-p1.jpg";
import walletRecPhrase2 from "./assets/wallet-generation/record-phrase-p2.jpg";
import walletRecPhrase3 from "./assets/wallet-generation/record-phrase-p3.jpg";
import walletPasscode from "./assets/wallet-generation/passcode.jpg";
import walletFinal from "./assets/wallet-generation/final-wallet.jpg";

// ACCORDION
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Help = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  });

  // CUSTOM STYLES FOR PAGE
  const useStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        backgroundColor: "#fff",
        margin: 0,
      },
      a: {
        textDecoration: 'none',
        color: '#9334ff',
        cursor: 'hand'
      }
    },
    root: {
      flexGrow: 1,
    },
    list: {
      lineHeight: '1.5',
      margin: 0,
      paddingLeft: 15,
      color: '#8c8c8c',
      '& li': {
        padding: '0 0 20px',
      },
    },
    innerList: {
      padding: '10px 24px',
      '& li': {
        fontSize: 'small',
      },
      '& li:last-child': {
        padding: 0,
      }
    },
    bodyPaper: {
      color: '#000',
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    step: {
      marginBottom: '30px',
      '& .header': {
        marginBottom: 14
      },
      '& .body': {
        color: '#8c8c8c'
      }
    },
    accordionHeading: {

    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    inPageNavigation: {
      '& Button': {
        [theme.breakpoints.down('sm')]: {
          width: '100%'
        },
      },
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
        <Header />
        <Container style={{ padding: '1vw' }}>
          {/* main content goes here */}
          <Paper elevation={0} className={classes.bodyPaper}>
            <Container style={{ padding: '40px 22px', textAlign: 'left' }}>
              <Typography variant="h4" style={{ fontWeight: 'bold', marginBottom: 30 }}>
                Help Guide
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 20 }}>
                  Learn about NFTs, how to setup your wallet, purchase Solana and FAQs answered
                  </Typography>
                  
                    <ul className={classes.list}>
                      <Typography>
                      <li>The VP Bunny NFT collection mint is ONLY available on the official <a href="https://nft.lasvegasvp.com/#Recruit">Bunny Recruiter</a>.</li>
                      <li>NEVER share your Solana wallet seed phrase, or private key with anybody.</li>
                      <li>Be aware of impersonators! VP and crew will NEVER reach out to you directly to offer support, ask for your account information, ask you to connect your wallet, or ask you to send nft or funds to any wallets.</li>
                      <li>Official NFT information will ONLY be posted on our website, official social media accounts, or <a href="https://discord.gg/lasvegasvp">official Discord server</a>.</li>
                      <li>We will NEVER do a surprise drop or a limited sale. You will know in advance when it happens, and it will exclusively come from an official account.</li>
                      </Typography>
                    </ul>
                  
                </Grid>
                <Grid item xs={12} md={4}>
                  <img src={helpGuide} style={{ width: '100%' }} alt="Help Guide" />
                </Grid>

                <Grid item xs={12} className={classes.inPageNavigation}>
                  <HashLink smooth to={'/help#collectibles'}>
                    <Button variant="outlined" color="primary" style={{ margin: '0 30px 20px 0', textTransform: 'capitalize' }}>
                      VP Bunny NFTs FAQs
                    </Button>
                  </HashLink>
                  <HashLink smooth to={'/help#generatingwallet'}>
                    <Button variant="outlined" color="primary" style={{ margin: '0 30px 20px 0', textTransform: 'capitalize' }}>
                      Generating A Wallet
                    </Button>
                  </HashLink>
                  <HashLink smooth to={'/help#howtobuysolana'}>
                    <Button variant="outlined" color="primary" style={{ margin: '0 30px 20px 0', textTransform: 'capitalize' }}>
                      How To Buy Solana
                    </Button>
                  </HashLink>
                  <HashLink smooth to={'/help#nftbasics'}>
                    <Button variant="outlined" color="primary" style={{ margin: '0 30px 20px 0', textTransform: 'capitalize' }}>
                      NFT Basics
                    </Button>
                  </HashLink>
                  <HashLink smooth to={'/help#support'}>
                    <Button variant="outlined" color="primary" style={{ margin: '0 30px 20px 0', textTransform: 'capitalize' }}>
                      Contact Support
                    </Button>
                  </HashLink>
                </Grid>
              </Grid>

              <Typography variant="h4" style={{ fontWeight: 'bold', margin: '30px 0 0' }} id="collectibles">
                VP Bunny NFTs FAQs
              </Typography>
              <Typography style={{ margin: '20px 0 30px' }}>
                Wondering what is included in a VP Bunny NFT? Looking for more information? Wondering how to redeem your NFT? Look no further.
              </Typography>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What do I receive after minting (buying) a VP Bunny NFT?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    When you mint a VP Bunny NFT, a random selection of 1 of 2,222 possible digital collectibles is deposited into your Solana wallet. These digital collectibles consist of one of the unique, one-of-a-kind, generative VP Bunny art. Each NFT grants access to full VP video archive and is also acts as an event passes for all future VP events. The 2 rare GOLD PASS NFTs and 5 SILVER PASS NFTs are also redeemable for a Dine & Play experience. 
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What does it mean to mint a VP Bunny NFT?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    When you mint an NFT, you begin its existence on the blockchain and become its first owner. Similar to how coins are minted and added into circulation, minting an NFT certifies the token as unique and adds it to the blockchain for the first time.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>How do I redeem my GOLD or SILVER PASS NFT?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    To redeem for a Dine & Play experience, visit <a href="https://nft.lasvegasvp.com/redeem">Redeem page</a> and submit your information. You will then be contacted to coordinate the Dine & Play experience. If you decide to sell your NFT, the unique digital collectable will be sent to the new owner as well as the rights for all future redemptions. Each NFT's Dine & Play experience can only be redeemed once per year.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>Does the VP Bunny NFT have to be in my Solana wallet in order to redeem?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes. The VP Bunny NFT must be in your Solana wallet at the time of redemption.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>How can I check if a GOLD/SILVER PASS NFT has already been redeemed?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    The 2 GOLD and 5 SILVER PASS NFTS will be featured on the webpage with their redemption status listed for the year.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>Are VP Bunny NFTs available worldwide?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Yes. However, you must come to Las Vegas, Nevada, USA when redeeming your Dine & Play experience.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>I still have more questions. Who do I contact?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                  Please email us at nft@lasvegasvp.com or join our Discord at https://discord.gg/lasvegasvp
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Typography variant="h4" style={{ fontWeight: 'bold', margin: '50px 0 40px' }} id="generatingwallet">
                Generating A Solana Wallet (with Solflare)
              </Typography>

              <Grid container spacing={3} md={9} style={{ margin: '30px 0 0 -12px' }}>
                <Grid item xs={12} md={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 16 }}>
                      Step 1
                    </Typography>
                    <Typography>
                      Download Solflare's mobile app for either <a href="https://apps.apple.com/us/app/solflare/id1580902717" target="_blank" rel="noreferrer">iOS</a> or <a href="https://play.google.com/store/apps/details?id=com.solflare.mobile" target="_blank" rel="noreferrer">Android</a>.
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <img src={walletSplash} style={{ width: '100%' }} alt="Wallet Generation Step 1" />
                </Grid>
              </Grid>

              <Grid container spacing={3} md={9} style={{ margin: '30px 0 0 -12px' }}>
                <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 16 }}>
                      Step 2
                    </Typography>
                    <Typography>
                    Select <strong>Create a new wallet</strong>, swipe through the reminders about how to store your <a href="https://academy.solflare.com/what-is-a-mnemonic-phrase-and-how-does-it-work/" target="_blank" rel="noreferrer">recovery phrase</a>, and select <strong>continue</strong>.
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <img src={walletPrivacy} style={{ width: '100%' }} alt="Wallet Generation Step 2" />
                </Grid>
                <Grid item xs={12} md={3}>
                  <img src={walletRecovery} style={{ width: '100%' }} alt="Wallet Generation Step 2" />
                </Grid>
              </Grid>

              <Grid container spacing={3} md={9} style={{ margin: '30px 0 0 -12px' }}>
                <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 16 }}>
                      Step 3
                    </Typography>
                    <Typography>
                      You'll be prompted to write down your recovery phrase word for word.
                    </Typography>
                    <Typography>
                      Don't worry, there are only 12 words.
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <img src={walletRecPhrase1} style={{ width: '100%' }} alt="Wallet Generation Step 3" />
                </Grid>
                <Grid item xs={12} md={3}>
                  <img src={walletRecPhrase2} style={{ width: '100%' }} alt="Wallet Generation Step 3" />
                </Grid>
              </Grid>

              <Grid container spacing={3} md={9} style={{ margin: '30px 0 0 -12px' }}>
                <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 16 }}>
                      Step 4
                    </Typography>
                    <Typography gutterBottom>
                      You'll be asked to choose two random words from the phrase to ensure that you didn't lose it.
                    </Typography>
                    <Typography>
                      Then you'll be prompted to enter a passcode. You can skip this step if you don't want to protect your account with a password.
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <img src={walletRecPhrase3} style={{ width: '100%' }} alt="Wallet Generation Step 4" />
                </Grid>
                <Grid item xs={12} md={3}>
                  <img src={walletPasscode} style={{ width: '100%' }} alt="Wallet Generation Step 4" />
                </Grid>
              </Grid>

              <Grid container spacing={3} md={9} style={{ margin: '30px 0 0 -12px' }}>
                <Grid item xs={12} md={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 16 }}>
                      That's it!
                    </Typography>
                    <Typography>
                      <p>In order to get your public key, just click on the copy button to copy the 44 digit key.</p>
                      <p>You can now enjoy all the powerful features that Solflare has to offer.</p>
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <img src={walletFinal} style={{ width: '100%' }} alt="Wallet Final" />
                </Grid>
              </Grid>

              <Typography variant="h4" style={{ fontWeight: 'bold', margin: '50px 0 0' }} id="howtobuysolana">
                How to buy Solana?
              </Typography>
              <Typography style={{ margin: '24px 0 30px' }}>
                When it comes to buying crypto, you have a lot of options. Fortunately you can buy Solana with the <a href="https://www.coinbase.com/signup" target="_blank" rel="noreferrer">Coinbase app</a> anywhere Coinbase is available. It’s quick, easy, and secure. Here’s how to buy Solana with the Coinbase app for U.S. residents.
              </Typography>

              {/* step */}
              <div className={classes.step}>
                <Typography gutterBottom className="header">
                  1. Create a Coinbase account
                </Typography>
                <Typography variant="body2" gutterBottom className="body">
                  Download the Coinbase app and start the sign up process. You will need a valid ID and may be asked for proof of address in order to transact, so be sure to have those ready. Verifying your ID may take longer than a few minutes, depending on where you live.
                </Typography>
              </div>
              
              {/* step */}
              <div className={classes.step}>
                <Typography gutterBottom className="header">
                  2. Add a payment method
                </Typography>
                <Typography variant="body2" gutterBottom className="body">
                Tap on the payment method box and connect a payment method. You can use a bank account, debit card or initiate a wire.
                </Typography>
              </div>
              
              {/* step */}
              <div className={classes.step}>
                <Typography gutterBottom className="header">
                  3. Start a trade
                </Typography>
                <Typography variant="body2" gutterBottom className="body">
                  Press <img src={coinbaseTradeIcon} style={{ width: '24px' }} alt="trade icon" /> then select “Buy” from the list of options.
                </Typography>
              </div>

              {/* step */}
              <div className={classes.step}>
                <Typography gutterBottom className="header">
                  4. Select Solana from the list of assets
                </Typography>
                <Typography variant="body2" gutterBottom className="body">
                  Search for Solana by typing "Solana" into the search bar. When you see Solana show up in the results, tap it to open up the purchase screen.
                </Typography>
              </div>

              {/* step */}
              <div className={classes.step}>
                <Typography gutterBottom className="header">
                  5. Enter the amount you want to buy
                </Typography>
                <Typography variant="body2" gutterBottom className="body">
                  Use the number pad to input the amount you want to spend in your local currency. The app will automatically convert that into a Solana amount.
                </Typography>
              </div>
              
              {/* step */}
              <div className={classes.step}>
                <Typography gutterBottom className="header">
                  6. Finalize your purchase
                </Typography>
                <Typography variant="body2" gutterBottom className="body">
                  Tap “Preview buy” when ready. You’ll be shown the details of your purchase. Make sure everything looks good and then confirm your purchase. That’s it, you’ve bought Solana.
                </Typography>
              </div>

              <Typography variant="h4" style={{ fontWeight: 'bold', margin: '50px 0 0' }} id="nftbasics">
                NFT Basics
              </Typography>
              <Typography style={{ margin: '24px 0 30px' }}>
                NFT stands for non-fungible token. It is a unique token that you can buy, sell, or hold. These tokens can represent just about anything, and they use blockchain technology to prove ownership. Ownership of a VP Bunny NFT represents unique access to physical and virtual VP experiences as well as digital perks.
                <h3>NFT FAQs</h3>

              </Typography>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What is an NFT?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    NFT stands for non-fungible token. It is a one-of-a-kind digital token that you can buy or sell. These tokens can represent just about anything, and they use blockchain technology to prove ownership. Sometimes they are associated with a digital image, or video. Sometimes they can be redeemed for a perk. Sometimes the owner is entitled to an experience, like a dinner. VP Bunny NFTs represent access to special streams and video archive, various events, dine and play experiences and more.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What are NFTs used for?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    NFTs can take a number of forms. The most common use case today is the sale and exchange of digital art. Ownership of an NFT can grant you access to real world experiences and physical items. Some people even buy NFTs purely for their emotional value, like a piece of art. We are still discovering the unique ways NFTs can be used.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What is a Blockchain?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    A blockchain is a ledger of transactions distributed amongst many computers. It is public and immutable, meaning that the transactions that occur on it are irreversible and can be referenced in the future. The blockchain enables for the exchange of these NFTs in a decentralized, peer-to-peer format.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What does it mean to mint an NFT?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Similar to how coins are minted and added into circulation, minting an NFT certifies the token as unique and adds it to the blockchain. By minting an NFT, you begin its existence on the blockchain and become its first owner.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>Are NFTs bad for the environment?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    VP Bunny NFTs are minted on Solana, a high-performance, energy-efficient blockchain. A transaction on Solana takes less energy than two Google searches, and 24 times less energy than charging your phone.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What is a crypto wallet?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    A crypto wallet is a secure place where your private key is stored. Think of it as your privately owned address on the internet. When you create a Solana wallet with Solflare or other wallet app, a digital wallet is created for you. NFTs are stored on the decentralized blockchain, and your private key acts as your address from which to send and receive NFTs and cryptocurrencies like Bitcoin or Solana.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* accordion item */}
              <Accordion style={{ backgroundColor: '#fff', color: '#333'}}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ color: '#333' }} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography className={classes.accordionHeading}><b>What can I do with my digital NFT?</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    Anything you'd like! You can download the file, show it off online, text it to your friends, email it to your grandma, or stare at it in your wallet. In the future, you will be able to show off your NFTs across virtual spaces.
                  </Typography>
                </AccordionDetails>
              </Accordion>


              <Typography variant="h4" style={{ fontWeight: 'bold', margin: '50px 0 0' }} id="support">
                Contact Support
              </Typography>
              <Typography style={{ margin: '24px 0 30px' }}>
                For additional support, contact <a href="mailto:nft@lasvegasvp.com">nft@lasvegasvp.com</a> or join our Discord at <a href="https://discord.gg/lasvegasvp">discord.gg/lasvegasvp</a>.
              </Typography>

              {/* END OF BODY CONTAINER, DON'T ADD STUFF UNDER HERE */}
            </Container>
          </Paper>
        </Container>
        <Footer />
        <BackToTop />
    </div>
  );
};

export default Help;